<template>
  <div class="fill-height">
    <div class="fill-height d-flex flex-column justify-center align-center">
      <h1 class="text-h2 grey--text text--darken-3">
        Welcome to
        <span class="primary--text font-weight-thin">masterTime</span>
      </h1>
      <div
        v-if="user && user.email"
        class="mt-6"
        style="font-size: 28px; color: #555"
      >
        {{ user.email }}
      </div>
      <div
        v-else
        class="mt-6 d-flex flex-column align-center"
        style="font-size: 28px; color: #555"
      >
        <div>{{ user.fullName }}</div>
        <div>รหัส : {{ user.employee_code }}</div>
        <div>
          บทบาท :
          <span v-if="employeePolicy.personal_policy_uuid"
            ><v-chip
              color="cyan"
              text-color="white"
              small
              class="mr-2 my-1"
              :key="employeePolicy.employee_uuid"
            >
              ส่วนตัว
            </v-chip></span
          >
          <span v-if="employeePolicy.roles && employeePolicy.roles.length > 0">
            <v-chip
              small
              class="mr-2 my-1"
              v-for="role in employeePolicy.roles"
              :key="role.role_uuid"
            >
              {{ role.title }}
            </v-chip>
          </span>
          <span v-else>-</span>
        </div>
      </div>

      <div class="mt-16 text-center">
        <div class="red--text" style="font-weight: 600">
          ข้อมูล Transaction จะถูกบันทึกเป็นเวลาสูงสุด
          {{ company.data_retention_period }} เดือน
          หลังจากนั้นข้อมูลจะถูกลบอัตโนมัติ
        </div>
        <div
          class="mt-2 grey--text text--darken-3 body-2"
          style="font-weight: 500"
        >
          ข้อมูล Transaction เก่าที่สุด ณ วันนี้คือ
          {{ oldestTransactionDate }}
        </div>
        <div v-if="company.activate_end_date">
          <v-divider class="my-4"></v-divider>
          <div
            class="mt-2 grey--text text--darken-3 body-2"
            style="font-weight: 500"
          >
            <span
              style="font-weight: 600"
              :class="{ 'red--text': isExpiringWithinMonth }"
            >
              Web Application สามารถใช้งานได้จนถึงวันที่
              {{ company.activate_end_date | formatDate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Home',
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: true },
    ])
  },
  computed: {
    user() {
      return this.$store.state.authentication.user
    },
    company() {
      return this.$store.state.company.company
    },
    employeePolicy() {
      return this.$store.state.employeePolicy.employeePolicy
    },
    oldestTransactionDate() {
      const today = new Date()
      const retentionMonths = this.company.data_retention_period || 0
      const oldestDate = new Date(
        today.getFullYear(),
        today.getMonth() - retentionMonths,
        today.getDate()
      )
      return oldestDate.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
    isExpiringWithinMonth() {
      if (!this.company.activate_end_date) return false
      const today = new Date()
      const endDate = new Date(this.company.activate_end_date)
      const oneMonthFromNow = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        today.getDate()
      )

      return endDate <= oneMonthFromNow
    },
  },
  created() {
    if (!this.user?.email) {
      this.loadDataApi()
    }
  },
  filters: {
    formatDate(date) {
      if (!date) return '-'
      const dateObj = new Date(date)
      return dateObj.toLocaleDateString('th-TH', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    },
  },
  methods: {
    ...mapActions({
      getEmployeePolicy: 'employeePolicy/getEmployeePolicy',
      fetchCompany: 'company/fetchCompany',
    }),
    async loadDataApi() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          employee_uuid: this.user.uuid,
        }

        await Promise.all([
          this.fetchCompany(company_uuid),
          this.getEmployeePolicy(payload),
        ])
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
  },
}
</script>
